import { RecordForm, type RelatedRows } from "@/components/masters/RecordForm";
import {
  createRecordAction,
  updateRecordAction,
} from "@/lib/actions/masters";
import type { MasterRecord, MasterRecordPayload, MasterSummary } from "@/lib/api/types";

type Props = {
  sport: string;
  master: MasterSummary;
  related: RelatedRows;
  record?: MasterRecord;
  /** Pre-selected parent when creating inside an existing branch. */
  parentCode?: string;
};

/** Binds the generic form to the right server action. Server components can't
 * pass closures over server actions, so the choice is made here. */
export function RecordFormClient({ sport, master, related, record, parentCode }: Props) {
  const onSave = (payload: MasterRecordPayload) =>
    record === undefined
      ? createRecordAction(sport, master.code, payload)
      : updateRecordAction(sport, master.code, record.code, payload);

  return (
    <RecordForm
      sport={sport}
      master={master}
      related={related}
      record={record}
      parentCode={parentCode}
      onSave={onSave}
    />
  );
}
